var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-nav-v2"},_vm._l((_vm.items),function(item){return _c('router-link',{key:item.path,class:{ active: _vm.$route.path === item.path },attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.nameKey ? _vm.$t(item.nameKey) : item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }